const menuButton = document.querySelector('.menu-toggle');
const mobileMenu = document.getElementById('MobileMenu');
function closeMenu() {
  if (!menuButton || !mobileMenu) return;
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', 'Open navigation');
  mobileMenu.hidden = true;
}
menuButton?.addEventListener('click', () => {
  const expanded = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!expanded));
  menuButton.setAttribute('aria-label', expanded ? 'Open navigation' : 'Close navigation');
  mobileMenu.hidden = expanded;
});
document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', closeMenu));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) {
    closeMenu();
    menuButton.focus();
  }
});

const reviewMode = document.body.dataset.reviewMode === 'true';
const privatePreview = document.body.dataset.privatePreview === 'true';
function galleryImageMetadata(value) {
  if (!value || typeof value !== 'object') return null;
  const width = Number(value.width);
  const height = Number(value.height);
  if (!Number.isInteger(width) || width <= 0 || !Number.isInteger(height) || height <= 0) return null;
  function imageUrl(source) {
    if (typeof source !== 'string' || !source.trim()) return null;
    try {
      const url = new URL(source, window.location.href);
      return ['https:', 'http:'].includes(url.protocol) ? source : null;
    } catch { return null; }
  }
  const src = imageUrl(value.src);
  const expandedSrc = imageUrl(value.expandedSrc || value.src);
  if (!src || !expandedSrc || typeof value.alt !== 'string') return null;
  function sourceSet(value) {
    if (value == null || value === '') return '';
    if (typeof value !== 'string') return null;
    return value.split(',').every(candidate => {
      const match = candidate.trim().match(/^(\S+)\s+([1-9]\d*)w$/);
      return match && imageUrl(match[1]);
    }) ? value : null;
  }
  const srcset = sourceSet(value.srcset);
  const expandedSrcset = sourceSet(value.expandedSrcset);
  if (srcset === null || expandedSrcset === null) return null;
  return {id:String(value.id ?? ''), src, srcset, sizes:typeof value.sizes === 'string' ? value.sizes : '', expandedSrc, expandedSrcset, expandedSizes:typeof value.expandedSizes === 'string' ? value.expandedSizes : '', alt:value.alt, width, height};
}
function fitGalleryImage(gallery) {
  const image = gallery?.querySelector('[data-gallery-image]');
  if (!image || typeof image.getBoundingClientRect !== 'function') return;
  const bounds = image.getBoundingClientRect();
  const sourceWidth = Number(image.getAttribute('width'));
  const sourceHeight = Number(image.getAttribute('height'));
  const paintedWidth = Math.min(bounds.width, bounds.height * sourceWidth / sourceHeight);
  if (paintedWidth > 0) image.setAttribute('sizes', `${Math.ceil(paintedWidth)}px`);
}
function loadArtworkEnlargement(dialog) {
  const image = dialog?.querySelector('img');
  if (!image?.dataset.imageSrc) return;
  image.setAttribute('sizes', image.dataset.imageSizes || '90vw');
  image.setAttribute('srcset', image.dataset.imageSrcset || '');
  image.src = image.dataset.imageSrc;
}
function displayGalleryImage(gallery, value) {
  const metadata = galleryImageMetadata(value);
  const image = gallery?.querySelector('[data-gallery-image]');
  if (!image || !metadata) return;
  image.alt = metadata.alt;
  image.width = metadata.width;
  image.height = metadata.height;
  image.setAttribute('sizes', metadata.sizes);
  fitGalleryImage(gallery);
  image.setAttribute('srcset', metadata.srcset);
  image.src = metadata.src;
  image.dataset.galleryExpandedSrc = metadata.expandedSrc;
  image.dataset.galleryExpandedSrcset = metadata.expandedSrcset;
  image.dataset.galleryExpandedSizes = metadata.expandedSizes;
  gallery.querySelectorAll('[data-gallery-src]').forEach(button => {
    const selected = metadata.id ? button.dataset.galleryId === metadata.id : button.dataset.gallerySrc === metadata.src;
    button.setAttribute('aria-pressed', String(selected));
  });
  const dialog = document.querySelector('[data-artwork-dialog]');
  const enlargedImage = dialog?.querySelector('img');
  if (enlargedImage) {
    enlargedImage.dataset.imageSrc = metadata.expandedSrc;
    enlargedImage.dataset.imageSrcset = metadata.expandedSrcset;
    enlargedImage.dataset.imageSizes = metadata.expandedSizes;
    enlargedImage.alt = metadata.alt;
    enlargedImage.width = metadata.width;
    enlargedImage.height = metadata.height;
    if (dialog.getAttribute('open') !== null) loadArtworkEnlargement(dialog);
  }
}
function syncFramePreview(gallery) {
  if (!gallery) return;
  const dialog = document.querySelector('[data-artwork-dialog]');
  if (dialog) {
    dialog.dataset.finish = gallery.dataset.finish;
    dialog.dataset.view = gallery.dataset.view;
  }
  const note = gallery.querySelector('[data-gallery-note]');
  if (note) note.textContent = gallery.dataset.view === 'artwork' ? 'The artwork without illustrative framing.' : gallery.dataset.finish === 'unframed' ? 'Print preview.' : 'Illustrative frame preview.';
  fitGalleryImage(gallery);
}
function syncPrintGeometry(gallery, sizeControl) {
  if (!gallery || !sizeControl) return;
  const selectedSize = [...sizeControl.options].find(option => option.value === sizeControl.value);
  const paperWidth = Number(selectedSize?.dataset.paperWidthMm);
  const paperHeight = Number(selectedSize?.dataset.paperHeightMm);
  const borderMm = Math.max(12.7, Number(gallery.dataset.printBorderMm) || 12.7);
  if (!(paperWidth > borderMm * 2 && paperHeight > borderMm * 2)) return;
  const orientation = paperWidth > paperHeight ? 'landscape' : paperWidth < paperHeight ? 'portrait' : 'square';
  for (const surface of [gallery, document.querySelector('[data-artwork-dialog]')]) {
    if (!surface) continue;
    surface.dataset.orientation = orientation;
    surface.style.setProperty('--paper-ratio', `${paperWidth}/${paperHeight}`);
    surface.style.setProperty('--wood-frame-inset', `${100 * 12 / (paperWidth + 24)}%`);
    surface.style.setProperty('--aluminium-frame-inset', `${100 * 10 / (paperWidth + 20)}%`);
    surface.style.setProperty('--print-inner-width', `${100 * (1 - borderMm * 2 / paperWidth)}%`);
    surface.style.setProperty('--print-inner-height', `${100 * (1 - borderMm * 2 / paperHeight)}%`);
  }
}
document.querySelectorAll('.product-form').forEach(form => {
  const variants = JSON.parse(form.querySelector('[data-variants]')?.textContent || '[]');
  const select = form.querySelector('[data-variant-select]');
  const gallery = document.querySelector('[data-product-gallery]');
  const finishButtons = [...form.querySelectorAll('[data-finish-select]')];
  const optionControls = [...form.querySelectorAll('[data-product-option]')];
  const optionButtons = [...form.querySelectorAll('[data-option-select]')];
  if (!select) return;
  function syncOptions(variant) {
    optionControls.forEach(control => {
      const index = Number(control.dataset.optionIndex);
      control.value = variant.options[index];
      // A finish exists only when its Size/Frame combination has a real variant.
      // Inventory status controls purchasing separately, so private proofs remain browsable.
      [...control.options].forEach(option => {
        option.disabled = !variants.some(item => item.options?.[index] === option.value &&
          optionControls.every(other => other === control || other.dataset.optionName === 'Frame' ||
            item.options?.[Number(other.dataset.optionIndex)] === other.value));
      });
    });
    optionButtons.forEach(button => {
      const control = optionControls.find(item => item.dataset.optionIndex === button.dataset.optionIndex);
      const option = [...control.options].find(item => item.value === button.dataset.optionValue);
      button.disabled = option.disabled;
      button.setAttribute('aria-pressed', String(control.value === button.dataset.optionValue));
    });
    const sizeControl = optionControls.find(control => control.dataset.optionName === 'Size');
    const dimensions = form.querySelector('[data-paper-dimensions]');
    if (sizeControl && dimensions) {
      const index = Number(sizeControl.dataset.optionIndex);
      const selectedSize = [...sizeControl.options].find(option => option.value === sizeControl.value);
      const frameIndex = Number(optionControls.find(control => control.dataset.optionName === 'Frame')?.dataset.optionIndex);
      const sizeVariants = variants.filter(item => item.options?.[index] === sizeControl.value);
      const unframedOnly = sizeVariants.length > 0 && sizeVariants.every(item => item.options?.[frameIndex] === 'No frame');
      const measurements = selectedSize?.dataset.paperMeasurements || sizeControl.value;
      const ukPaperSize = form.querySelector('[data-uk-paper-size]');
      if (ukPaperSize) ukPaperSize.value = measurements.split(' / ').at(-1);
      dimensions.textContent = `${measurements} paper. Includes the white border.${unframedOnly ? ' Available unframed only.' : ' Framing adds to the overall dimensions.'}`;
    }
  }
  function selectVariant(updateUrl = true) {
    const variant = variants.find(item => String(item.id) === select.value);
    if (!variant) return;
    if (optionControls.length) syncOptions(variant);
    syncPrintGeometry(gallery, optionControls.find(control => control.dataset.optionName === 'Size'));
    const button = form.querySelector('[data-add-to-cart]');
    if (button) {
      button.disabled = reviewMode ? false : privatePreview || !variant.available;
      button.textContent = reviewMode ? 'Add to review bag' : privatePreview ? 'Ordering opens soon' : variant.available ? 'Add to bag' : 'Unavailable';
    }
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:variant.currency || window.Shopify?.currency?.active || 'USD'});
    const price = document.querySelector('[data-product-price]');
    if (price) price.textContent = variant.price > 0 ? money.format(variant.price / 100) : 'Price to be confirmed';
    finishButtons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.finishSelect === select.value)));
    if (gallery) gallery.dataset.finish = variant.finish;
    if (gallery && !reviewMode) displayGalleryImage(gallery, variant.image);
    syncFramePreview(gallery);
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
  }
  select.addEventListener('change', () => selectVariant());
  optionControls.forEach(control => control.addEventListener('change', () => {
    const matches = variants.filter(item => item.options?.[Number(control.dataset.optionIndex)] === control.value);
    let variant = matches.find(item => optionControls.every(other => item.options?.[Number(other.dataset.optionIndex)] === other.value));
    if (!variant) {
      // A new size may not support the current frame. Use a real combination
      // rather than leaving the previous size's variant in the bag.
      const frameIndex = Number(optionControls.find(item => item.dataset.optionName === 'Frame')?.dataset.optionIndex);
      variant = matches.find(item => item.options?.[frameIndex] === 'No frame') || matches[0];
    }
    if (variant) {
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
  }));
  optionButtons.forEach(button => button.addEventListener('click', () => {
    const control = optionControls.find(item => item.dataset.optionIndex === button.dataset.optionIndex);
    control.value = button.dataset.optionValue;
    control.dispatchEvent(new Event('change', {bubbles:true}));
    gallery?.querySelector('[data-gallery-view="print"]')?.click();
  }));
  finishButtons.forEach(button => button.addEventListener('click', () => {
    select.value = button.dataset.finishSelect;
    select.dispatchEvent(new Event('change', {bubbles:true}));
    gallery?.querySelector('[data-gallery-view="print"]')?.click();
  }));
  const requested = new URL(window.location.href).searchParams.get('variant');
  if (variants.some(item => String(item.id) === requested)) select.value = requested;
  selectVariant(false);
  if (optionControls.length && variants.every(item => Array.isArray(item.options))) {
    form.querySelector('[data-product-option-controls]').hidden = false;
    form.querySelector('[data-variant-fallback]').hidden = true;
  }
  if (privatePreview && !reviewMode) form.addEventListener('submit', event => event.preventDefault());
});

document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const views = [...gallery.querySelectorAll('[data-gallery-view]')];
  views.forEach(button => button.addEventListener('click', () => {
    gallery.dataset.view = button.dataset.galleryView;
    views.forEach(view => view.setAttribute('aria-pressed', String(view === button)));
    syncFramePreview(gallery);
  }));
  gallery.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    if (!button.dataset.galleryMetadata) return;
    try { displayGalleryImage(gallery, JSON.parse(button.dataset.galleryMetadata)); } catch { return; }
  }));
  fitGalleryImage(gallery);
});
window.addEventListener?.('resize', () => document.querySelectorAll('[data-product-gallery]').forEach(fitGalleryImage));

const artworkDialog = document.querySelector('[data-artwork-dialog]');
let previousOverflow;
document.querySelector('[data-artwork-expand]')?.addEventListener('click', () => {
  if (!artworkDialog) return;
  const currentImage = document.querySelector('[data-gallery-image]');
  const enlargedImage = artworkDialog.querySelector('img');
  if (currentImage && enlargedImage) {
    enlargedImage.dataset.imageSrc = currentImage.dataset.galleryExpandedSrc || currentImage.src;
    enlargedImage.dataset.imageSrcset = currentImage.dataset.galleryExpandedSrcset || '';
    enlargedImage.dataset.imageSizes = currentImage.dataset.galleryExpandedSizes || '90vw';
    enlargedImage.alt = currentImage.alt;
    enlargedImage.width = Number(currentImage.getAttribute('width'));
    enlargedImage.height = Number(currentImage.getAttribute('height'));
  }
  previousOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  artworkDialog.showModal();
  loadArtworkEnlargement(artworkDialog);
});
document.querySelector('[data-artwork-close]')?.addEventListener('click', () => artworkDialog.close());
artworkDialog?.addEventListener('close', () => {document.body.style.overflow = previousOverflow || '';});
artworkDialog?.addEventListener('click', event => {if (event.target === artworkDialog) artworkDialog.close();});
document.body.classList.add('js-ready');
